export default __webpack_public_path__ + "static/media/diamond-cut-5@2x.f56e18ac.png";